import React, { lazy, Suspense } from 'react';

const LazyWarrantyClaimsPage = lazy(() => import('./WarrantyClaimsPage'));

const WarrantyClaimsPage = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyWarrantyClaimsPage {...props} />
  </Suspense>
);

export default WarrantyClaimsPage;
